import { render, staticRenderFns } from "./RevisaCorreo.vue?vue&type=template&id=00940cf1&scoped=true&"
import script from "./RevisaCorreo.vue?vue&type=script&lang=js&"
export * from "./RevisaCorreo.vue?vue&type=script&lang=js&"
import style0 from "./RevisaCorreo.vue?vue&type=style&index=0&id=00940cf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00940cf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})
